import { useState } from 'react';
import { SubscriptionModalType } from '../types';

export function useSubscriptionModals() {
  const [activeModal, setActiveModal] = useState<SubscriptionModalType | null>(
    null
  );

  const openModal = (modal: SubscriptionModalType | null) =>
    setActiveModal(modal);
  const closeModal = () => {
    setActiveModal(null);
  };

  return {
    activeModal,
    openModal,
    closeModal,
  };
}
